export default {
    create_edit_gadget_chart: "Chart",
    create_edit_gadget_chart_description: "Customizable line charts or column charts to summarize report data",
    create_edit_gadget_edit_gadget: "Edit Gadget",
    create_edit_gadget_create_gadget: "Create Gadget",
    create_edit_gadget_changes_saved_sucessfully: "Changes Saved Successfully",

    create_edit_gadget_pie_title: "VidFleet Clips Request",
    create_edit_gadget_pie_description: "Pie charts to show the count of ClipRequest statuses",
    create_edit_gadget_firmware_description: "Column charts to summarize the Firmwares assigned to the devices",
    create_edit_gadget_unit_by_status: "Inactive Units Still Reporting",
    create_edit_gadget_stopped_reporting: "Active units that stopped reporting",
    create_edit_gadget_unit_status: "Unit Status",
    create_edit_gadget_maintenance_warnings: "Maintenance Warnings",
}